import React from "react";
import t from "../helpers/t";
// @ts-ignore
import Button from "./Button";
// @ts-ignore
import {$} from "../../../vendor";

type Props = {
    rbac?: any,
    icon?: string,
    label?: string,
    id?: string,
    eventHandler?: (event: MouseEvent) => void,
    url?:string,
    specialPermission?: any
}
const SidebarFooter = (props:Props) => {
    const {rbac, icon,label,id,eventHandler,url,specialPermission} = props;

    const onToggleLeftBar = (ev:any) => {
        $('#inb-c-sidebar').toggleClass('open');
        $('html,body').scrollTop(0);
    };

    return (
        <>
            <footer
                className="inb-c-left-bar__footer small-only-float-container"
                data-inb-action-link="write">
                <a href="#"
                   id="toggle-left-bar"
                   className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                    <i className="fi fi-filter"></i>
                    <span className="show-for-sr">{t('open_filter_menu')}</span>
                </a>
                { rbac.hasPermission(specialPermission) &&
                    <Button
                        label={label}
                        id={id}
                        url={url}
                        eventHandler={eventHandler}
                        icon={icon}
                    />
                }
            </footer>
        </>
    )
}
export default SidebarFooter;